var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { useInput, useInputState } from './components/input.hook';
export function useTextInput(props, ref) {
    var _a = useInputState(props, ref), value = _a.value, setValue = _a.setValue, inputProps = _a.inputProps, error = _a.error, errored = _a.errored, initialState = _a.initialState;
    var state = __assign(__assign({}, initialState), { emitChange: function (value, event) {
            if (!value) {
                value = '';
                if (event.target)
                    event.target['value'] = '';
            }
            setValue(value);
            props.onChangeValue && props.onChangeValue(value);
            props.onChange && props.onChange(event);
        } });
    var input = useInput(state, props);
    function onChange(event) {
        setValue(event.target.value);
        input.notify.notify(event.target.value, event);
    }
    React.useEffect(function () {
        if (value !== props.value) {
            setValue(props.value);
        }
    }, [props.value]);
    return {
        container: __assign(__assign({}, input.container), { error: props.error || error, errored: props.errored || errored }),
        input: __assign(__assign(__assign({}, inputProps), input.input), { value: value, onChange: onChange })
    };
}
